var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28594 12.7141C4.21829 13.6464 5.40618 14.2814 6.69939 14.5386C7.99259 14.7958 9.33304 14.6638 10.5512 14.1592C11.7694 13.6547 12.8106 12.8002 13.5431 11.7038C14.2757 10.6075 14.6667 9.31858 14.6667 8.00004C14.6667 6.6815 14.2757 5.39257 13.5431 4.29624C12.8106 3.19991 11.7694 2.34543 10.5512 1.84084C9.33304 1.33626 7.99259 1.20424 6.69939 1.46147C5.40618 1.71871 4.21829 2.35364 3.28594 3.28599",
    stroke: "#E8A941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.99996L10.3904 7.68761L10.6403 7.99996L10.3904 8.31231L10 7.99996ZM2 8.49996C1.72386 8.49996 1.5 8.2761 1.5 7.99996C1.5 7.72382 1.72386 7.49996 2 7.49996V8.49996ZM7.72377 4.35428L10.3904 7.68761L9.60957 8.31231L6.9429 4.97897L7.72377 4.35428ZM10.3904 8.31231L7.72377 11.6456L6.9429 11.0209L9.60957 7.68761L10.3904 8.31231ZM10 8.49996H2V7.49996H10V8.49996Z",
    fill: "#E8A941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoTo);
export default __webpack_public_path__ + "static/media/icon-go-to.7baee928a79970836268213e8c80e357.svg";
export { ForwardRef as ReactComponent };